// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 1237 ? "BaseComponent" : chunkId) + "." + {"391":"996dd19e","1237":"80a42531","1563":"e9b61a61","2872":"bd85c5c2","2918":"b747255e","7358":"972158b5"}[chunkId] + ".css";
};